var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronUp = function SvgChevronUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.646 14.36a.467.467 0 0 1 0-.68L12 9.5l4.354 4.18a.467.467 0 0 1 0 .68.515.515 0 0 1-.708 0L12 10.857l-3.646 3.501a.515.515 0 0 1-.708 0Z",
    clipRule: "evenodd"
  })));
};
export default SvgChevronUp;